import script from "./VerifyCodeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyCodeButton.vue?vue&type=script&setup=true&lang=js"

import "./VerifyCodeButton.vue?vue&type=style&index=0&id=11070dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11070dc6"]])

export default __exports__